import {
    defineComponent,
} from "vue";
import CommunityEngagementCoach from "../../components/CommunityEngagementCoach.js";
import { useLocale } from "../../locales/i18n.js";

export default defineComponent({
    setup() {
        const { i18n } = useLocale();

        return () => (
            <div class="tools-page">
                <div class="tools-hero">
                    <span class="tools-eyebrow">{i18n("tools.community_engagement.page.eyebrow")}</span>
                    <h1>{i18n("tools.community_engagement.page.title")}</h1>
                    <p>{i18n("tools.community_engagement.page.description")}</p>
                </div>

                <CommunityEngagementCoach />
            </div>
        );
    },
});
